import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {API} from '../App';
import {Card, CardHeader, CardTitle, CardContent} from './ui/card';

export default function SearchIndexingPreference() {
  const [enabled, setEnabled] = useState(false);
  const [ready, setReady] = useState(false);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  useEffect(() => {
    let active = true;
    axios.get(`${API}/psychologist/search-indexing`).then(({data}) => {
      if (active) {setEnabled(data.enabled === true); setReady(true);}
    }).catch(() => {if (active) setMessage('Unable to load your indexing preference. Please reopen Settings to try again.');});
    return () => {active = false;};
  }, []);
  const change = async event => {
    const next = event.target.checked;
    setBusy(true); setMessage('');
    try {
      const {data} = await axios.put(`${API}/psychologist/search-indexing`, {enabled:next});
      setEnabled(data.enabled === true);
      setMessage(data.enabled ? 'Search indexing preference saved.' : 'Search indexing disabled.');
    } catch {setMessage('Unable to save your preference. Your previous setting has been kept.');}
    finally {setBusy(false);}
  };
  return <Card>
    <CardHeader><CardTitle>Google Search Indexing</CardTitle></CardHeader>
    <CardContent className="space-y-3">
      <label className="flex items-start gap-3">
        <input type="checkbox" className="mt-1" checked={enabled} disabled={!ready || busy} onChange={change} aria-describedby="search-indexing-help" />
        <span>Allow search engines to index my public professional profile</span>
      </label>
      <p id="search-indexing-help" className="text-sm text-gray-600">Off by default. When enabled, your approved, active and publicly published professional profile can appear in Google and other search engines. This does not change who can open your public profile. Turning it off removes your profile from the sitemap and asks search engines not to index it; existing search results may take time to update.</p>
      <p role="status" className="text-sm">{busy ? 'Saving…' : message}</p>
    </CardContent>
  </Card>;
}
